import React from 'react';
import './SearchBar.css';

/**
 * Reusable search bar component
 */
const SearchBar = ({ 
  value, 
  onChange, 
  onSearch,
  placeholder = "Search...", 
  className = '',
  showSearchButton = false,
  disabled = false,
  onClear
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  const handleClear = () => {
    onChange('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className={`search-bar ${className}`}>
      <div className="search-input-group">
        <input
          type="text"
          className="form-control search-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
        />
        {value && (
          <button 
            type="button" 
            className="btn btn-outline-secondary search-clear"
            onClick={handleClear}
            title="Clear search"
          >
            ×
          </button>
        )}
        {showSearchButton && (
          <button 
            type="button" 
            className="btn btn-primary search-button"
            onClick={() => onSearch && onSearch(value)}
            disabled={disabled}
          >
            Search
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
